export default "__VITE_ASSET__DYVSJUtI__"